/**
 * Context providers and hooks export
 * Centralized exports for all context providers and their hooks
 */

import React from 'react';

// ValidationContext exports
export {
  ValidationProvider,
  useValidation,
} from './ValidationContext';

// HighlightingContext exports
export {
  HighlightingProvider,
  useHighlighting,
  useHighlightingContext,
  validateBoundingBox,
  filterBoundingBoxesByPage,
} from './HighlightingContext';

// UIContext exports
export {
  UIProvider,
  useUI,
  useLoadingState,
  useNotifications,
  useConfirmationDialog,
} from './UIContext';

// AuthContext exports
export {
  AuthProvider,
  useAuth,
} from './AuthContext';

// ThemeContext exports
export {
  DynamicThemeProvider,
  useDynamicTheme,
} from './ThemeContext';

// Combined provider component for easy setup
import { ValidationProvider } from './ValidationContext';
import { HighlightingProvider } from './HighlightingContext';
import { UIProvider } from './UIContext';
import { AuthProvider } from './AuthContext';
import { DynamicThemeProvider } from './ThemeContext';

interface HITLContextProvidersProps {
  children: React.ReactNode;
}

/**
 * Combined context providers for the HITL Validation Interface
 * Wraps all context providers in the correct order
 */
export function HITLContextProviders({ children }: HITLContextProvidersProps) {
  return (
    <DynamicThemeProvider>
      <AuthProvider>
        <UIProvider>
          <ValidationProvider>
            <HighlightingProvider>
              {children}
            </HighlightingProvider>
          </ValidationProvider>
        </UIProvider>
      </AuthProvider>
    </DynamicThemeProvider>
  );
}